import React from 'react';
import './WorksSection.css';
import pinIcon from '../asset/icons/pin.svg';
import img1 from '../asset/images/restauro-architettonico-palazzo-castiglioni-milano.webp';
import img2 from '../asset/images/restauro-crocefisso-legno-pavia.webp';
import img3 from '../asset/images/restauro-castello-quart.webp';

const WorksSection = () => {
  // Project data
  const projects = [
    {
      id: 1,
      image: img1,
      location: 'Milano',
      title: 'Palazzo Castiglioni',
      type: 'Restauro architettonico e lapideo'
    },
    {
      id: 2,
      image: img2,
      location: 'Cava Manara, PV',
      title: 'Crocefisso processionale',
      type: 'Restauro ligneo'
    },
    {
      id: 3,
      image: img3,
      location: 'Quart, Valle d\'Aosta',
      title: 'Castello dei Signori di Quart',
      type: 'Restauro architettonico e lapideo'
    }
  ];

  return (
    <section className="works-section" id="lavori">
      <div className="container">
        <div className="works-header">
          <div className="section-title-decoration">
            <div className="decoration-line"></div>
            <div className="decoration-circle"></div>
            <div className="decoration-line"></div>
          </div>
          <h2 className="section-title">Selezione di opere restaurate</h2>
          <p className="section-description">
            Una selezione di alcune delle opere che ho restaurato, lavorando all'interno di team qualificati oppure occupandomi dell'intero ciclo di progettazione e lavorazione.
          </p>
        </div>
        
        <div className="works-slider">
          {projects.map(project => (
            <div key={project.id} className="project-card">
              <div 
                className="project-image" 
                style={{ backgroundImage: `url(${project.image})` }}
              >
                <div className="project-overlay">
                  <div className="project-location">
                    <div className="location-badge">
                      <img src={pinIcon} alt="Location" className="location-icon" />
                      <span>{project.location}</span>
                    </div>
                  </div>
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-type">{project.type}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
    </section>
  );
};

export default WorksSection; 